import { FC, useEffect } from 'react';
import { ENV } from 'src/config/env';

/**
 * Inject the Matomo Tag Manager script into the DOM.
 * https://matomo.org/faq/new-to-piwik/how-do-i-start-tracking-data-with-matomo-on-websites-that-use-react/
 *
 * @returns null
 */
export const TagManager: FC = () => {
    useEffect(() => {
        const _mtm = (window._mtm = window._mtm || []);
        _mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' });

        const script = document.createElement('script');
        script.async = true;
        script.src = getCampaign() === 'true' ? ENV.matomoTagManagerUrl2 : ENV.matomoTagManagerUrl;

        const firstScript = document.getElementsByTagName('script')[0];

        firstScript.parentNode!.insertBefore(script, firstScript);
    }, []);

    return null;
};

function getCampaign(): string {
    const params = new URLSearchParams(window.location.search);
    const campaign = params.get('campaign');

    if (campaign) {
        sessionStorage.setItem('campaign', 'true');
        return 'true';
    } else {
        return sessionStorage.getItem('campaign') ?? 'false';
    }
}
